/* eslint-disable @typescript-eslint/no-unnecessary-condition */

const cloneEvent = <T>(obj: T): T => {
  return JSON.parse(JSON.stringify(obj)) as T;
};

export const trackEvent = (ctaUrl: string, imageAlt: string) => {
  if (typeof window === 'undefined') return;

  window.ixisEventData = window.ixisEventData || [];

  const destinationUrl = ctaUrl.startsWith('#')
    ? `${window.location.href.split('#')[0]}${ctaUrl}`
    : ctaUrl;

  const event: IxisEventData = {
    link: destinationUrl,
    imageAlt,
    featureAppId: __FEATURE_APP_NAME__,
    featureAppBaseUrl: window.location.origin,
  };
  window.ixisEventData.push(cloneEvent(event));
};
